import { ScheduledReportsFormPage } from "./ScheduledReportsFormPage";

export default ScheduledReportsFormPage;
